
    import './styles.scoped.css';
    export default {
  "icon-shake": "awsui_icon-shake_1cbgc_kzt47_13",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_kzt47_1",
  "container-fade-in": "awsui_container-fade-in_1cbgc_kzt47_41",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_kzt47_1",
  "root": "awsui_root_1cbgc_kzt47_63",
  "status-error": "awsui_status-error_1cbgc_kzt47_72",
  "status-warning": "awsui_status-warning_1cbgc_kzt47_75",
  "status-success": "awsui_status-success_1cbgc_kzt47_78",
  "status-info": "awsui_status-info_1cbgc_kzt47_81",
  "status-stopped": "awsui_status-stopped_1cbgc_kzt47_84",
  "status-pending": "awsui_status-pending_1cbgc_kzt47_87",
  "status-in-progress": "awsui_status-in-progress_1cbgc_kzt47_90",
  "status-loading": "awsui_status-loading_1cbgc_kzt47_93",
  "status-not-started": "awsui_status-not-started_1cbgc_kzt47_96",
  "status-log": "awsui_status-log_1cbgc_kzt47_99",
  "color-override-red": "awsui_color-override-red_1cbgc_kzt47_102",
  "color-override-grey": "awsui_color-override-grey_1cbgc_kzt47_105",
  "color-override-blue": "awsui_color-override-blue_1cbgc_kzt47_108",
  "color-override-green": "awsui_color-override-green_1cbgc_kzt47_111",
  "color-override-yellow": "awsui_color-override-yellow_1cbgc_kzt47_114",
  "embedded": "awsui_embedded_1cbgc_kzt47_117",
  "container": "awsui_container_1cbgc_kzt47_41",
  "display-inline": "awsui_display-inline_1cbgc_kzt47_175",
  "icon": "awsui_icon_1cbgc_kzt47_13",
  "display-inline-block": "awsui_display-inline-block_1cbgc_kzt47_186",
  "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_kzt47_204"
};
  